import React, { useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Link,
  Tooltip,
} from '@mui/material';
import Logo from './components/Logo';

function App() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [showLink, setShowLink] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Optimistically set the success state.
    setShowLink(true);
    setMessage('Lets go! Good luck and enjoy the ride!');

    try {
      const response = await fetch('/start-challenge', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email }),
      });

      if (!response.ok) {
        // If the server returned an error, try to get the specific message.
        const data = await response.json();
        if (data && data.error) {
          // If we got a message, revert the optimistic state and show the error.
          setShowLink(false);
          setMessage(data.error);
        }
      }
    } catch (error) {
      // Per the original logic, network errors are ignored. We log it and let the optimistic UI state remain.
      console.error('An error occurred during fetch, but proceeding with success UI:', error);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Logo />
          <Typography component="h1" variant="h5" sx={{ ml: 2 }}>
            Impower Tech Challenge
          </Typography>
        </Box>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="name"
            label="Name"
            name="name"
            autoComplete="name"
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Tooltip placement='top' title="Please use the email address where you received the challenge invitation.">
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Tooltip>
          <Tooltip placement='top' title="Counting starts at the FIRST successful start challenge.">
            <Button
              type="submit"
              fullWidth
              disabled={showLink}
              style={{ backgroundColor: showLink ? 'rgba(59, 59, 59, 0.608)' : '#000000', color: '#ffffff', fontWeight: 'bold' }}
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              START CHALLENGE
            </Button>
          </Tooltip>
          {message && (
            <Typography
              color={showLink ? 'success' : 'error'}
              align="center"
            >
              {message}
            </Typography>
          )}
          {showLink && (
            <Link
              href="https://gitlab.com/impower-public/tech-challenge"
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              sx={{ display: 'block', textAlign: 'center' }}
            >
              Follow this link
            </Link>
          )}
        </Box>
      </Box>
    </Container>
  );
}

export default App;
